// initial state
const state = {
  incr_salary: {
    options: {
      status: [
        {label: '新创建', value: 0},
        {label: '加值中', value: 1},
        {label: '加值完成', value: 2},
        {label: '恢复中', value: 3},
        {label: '恢复完成', value: 4},
        {label: '无效', value: 5},
      ],
      type: [
        {label: '百分比', value: 1},
        {label: '固定金额', value: 2},
      ],
    },
    STATUS_CREATED: 0,
    STATUS_PROCESSING: 1,
    STATUS_PROCESSED: 2,
    STATUS_RECOVERING: 3,
    STATUS_RECOVERED: 4,
    STATUS_INVALID: 5,
  }
}

// getters
const getters = {}

// actions
const actions = {
  getCustomerBatchTable ({commit, state}, params) {
    let promised = request.alert('getCustomerBatchTable', params)
    return promised
  },
  getCustomerBatchDetail ({commit, state}, params) {
    let promised = request.alert('getCustomerBatchDetail', params)
    return promised
  },
  createCustomerBatchData ({commit, state}, params) {
    let promised = request.alert('createCustomerBatchData', params)
    return promised
  },
  updateCustomerBatchData ({commit, state}, params) {
    let promised = request.alert('updateCustomerBatchData', params)
    return promised
  },
  deleteCustomerBatchData ({commit, state}, params) {
    let promised = request.alert('deleteCustomerBatchData', params)
    return promised
  },
}

// mutations
const mutations = {}

export const customerBatch = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/customer-batch/customer-batch.store.js